import Moment from 'moment'
Moment.locale('es')

export default Moment



// WEBPACK FOOTER //
// ./src/app/shared/plugins/Moment.js